import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { findArray } from 'helpers/utils';
import { ColumnBib, ColumnNameH2H } from "components/common/TableColumns"
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import { useViewport } from 'components/general/useViewPort'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

function Ru7PlayerStats({ data, team }) {
  const { mirs_rsc } = useUrlFriendlyToParameters()
  let athletes = findArray(data?.results?.items, { startSortOrder: [team] })?.teamAthletes;

  let competitorNoc = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.organisation?.code;
  let competitorCode = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.code;
  let participant = findArray(data?.results?.items, { startSortOrder: [team] })?.participant;

  const tableColumns = useMemo(() =>
    [
      ColumnBib({ disableSort: true, label: 'HeaderNumber', expecialCase: true }),
      ColumnNameH2H({ showStarter: false }),
      {
        id: 'PlayerStatsPoints',
        Header: "Points",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 1,
        Cell: (props) => (
          findArray(props.cell.row.original.statsItems, { code: ['PTS'] }).value
        )
      },
      {
        id: 'PlayerStatsTry',
        Header: "Tries",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 2,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['TRY'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsConv',
        Header: "Conversions",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 3,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['CONV'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['CONV'] }).attempt;
          return (
            <>
              <PlayerStatsType value={value} attempt={attempt} />
            </>
          )
        }
      },
      {
        id: 'PlayerStatsPTY',
        Header: "Penalty Goals",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 4,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).attempt;
          return (
            <>
              <PlayerStatsType value={value} attempt={attempt} />
            </>
          )
        }
      },
      {
        id: 'PlayerStatsDROP',
        Header: "Drop Goals",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 5,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['DROP'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['DROP'] }).attempt;
          return (
            <>
              <PlayerStatsType value={value} attempt={attempt} />
            </>
          )
        }
      },
      {
        id: 'PlayerStatsYC',
        Header: "Yellow Cards",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 6,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['YC'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsRC',
        Header: "Red Cards",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 7,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['RC'] }).value}
            </>
          )
        }
      },
    ], []
  )

  const tableColumnsSM = useMemo(() =>
    [
      ColumnBib({ disableSort: true, label: 'HeaderNumber', expecialCase: true }),
      ColumnNameH2H({ showStarter: false, hideNoc: true }),
      {
        id: 'PlayerStatsPoints',
        Header: "Pts",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 1,
        Cell: (props) => (
          findArray(props.cell.row.original.statsItems, { code: ['PTS'] }).value
        )
      },
      {
        id: 'PlayerStatsTry',
        Header: "T",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 2,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['TRY'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsConv',
        Header: "C",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 3,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['CONV'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['CONV'] }).attempt;
          return (
            <>
              <PlayerStatsType value={value} attempt={attempt} />
            </>
          )
        }
      },
      {
        id: 'PlayerStatsPTY',
        Header: "PG",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 4,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).attempt;
          return (
            <>
              <PlayerStatsType value={value} attempt={attempt} />
            </>
          )
        }
      },
      {
        id: 'PlayerStatsDROP',
        Header: "DG",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 5,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['DROP'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['DROP'] }).attempt;
          return (
            <>
              <PlayerStatsType value={value} attempt={attempt} />
            </>
          )
        }
      },
      {
        id: 'PlayerStatsYC',
        Header: "YC",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 6,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['YC'] }).value}
            </>
          )
        }
      },
      {
        id: 'PlayerStatsRC',
        Header: "RC",
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 7,
        Cell: (props) => {
          return (
            <>
              {findArray(props.cell.row.original.statsItems, { code: ['RC'] }).value}
            </>
          )
        }
      },
    ], []
  )
  let _caption = <CaptionTeam competitorNoc={competitorNoc} participant={participant} />
  const { breakPoint } = useViewport();

  let columns = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsSM : tableColumns

  return (
    <>
      <MirsTable
        id={`mirs-table-player-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
        caption={_caption}
        data={athletes}
        columns={columns}
        keyRow={"athlete-code"}
        initialSortBy={[{ id: 'Bib', desc: false }]}
        colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '7' : '7'}
        showNavExtendedData={true}
        colIndex={1}
      />
    </>
  );
}

export default Ru7PlayerStats;

function CaptionTeam({ participant }) {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-1'>
        <Noc {...participant?.organisation} />
      </div>
      <strong>
        <Competitor hidePicture={true} {...participant} />
      </strong>
    </div >
  )
}

function PlayerStatsType({ value, attempt }) {
  if (value !== undefined) {
    return (
      <>
        {value}/{attempt}
      </>
    )
  }
}